"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Author () {
        return Author;
    },
    get CompanyFeedbackFiltersSchema () {
        return CompanyFeedbackFiltersSchema;
    },
    get CompanyFeedbackQuerySchema () {
        return CompanyFeedbackQuerySchema;
    },
    get CustomFieldValue () {
        return CustomFieldValue;
    },
    get Feedback () {
        return Feedback;
    },
    get Subject () {
        return Subject;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const Author = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string()
});
const CustomFieldValue = _zod.z.object({
    field_name: _zod.z.string(),
    value: _zod.z.unknown(),
    displayValue: _zod.z.string().optional()
});
const Subject = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    custom_field_values: _zod.z.record(_zod.z.string(), CustomFieldValue)
});
const Feedback = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    author: _zod.z.array(Author),
    categories: _zod.z.array(_zod.z.string()).optional(),
    content: _zod.z.string().optional(),
    feedback_message: _zod.z.string().optional(),
    last_updated: _zod.z.string(),
    request_message: _zod.z.string().optional(),
    response_to_request: _zod.z.boolean().optional(),
    shared_with: _models.FeedbackSharedWithModel,
    subject: _zod.z.array(Subject),
    deleted: _zod.z.boolean().optional(),
    feedback_request: _zod.z.boolean().optional()
});
const CompanyFeedbackQuerySchema = _zod.z.object({
    authorId: _zod.z.string().optional(),
    subjectId: _zod.z.string().optional(),
    sharedWith: _zod.z.string().optional(),
    categories: _zod.z.string().optional(),
    dateAfter: _zod.z.string().optional(),
    dateBefore: _zod.z.string().optional(),
    searchTerm: _zod.z.string().optional(),
    customFieldIds: _zod.z.string().optional(),
    responseToRequest: _zod.z.enum([
        "true",
        "false"
    ]).transform((v)=>v === "true").optional()
});
const CompanyFeedbackFiltersSchema = _zod.z.object({
    authorId: _zod.z.string().optional(),
    subjectId: _zod.z.string().optional(),
    sharedWith: _zod.z.string().optional(),
    categories: _zod.z.array(_zod.z.string()).optional(),
    dateAfter: _zod.z.string().optional(),
    dateBefore: _zod.z.string().optional(),
    searchTerm: _zod.z.string().optional(),
    customFieldIds: _zod.z.array(_zod.z.string()).optional(),
    responseToRequest: _zod.z.boolean().optional()
});
